module.exports = __webpack_public_path__ + "static/fonts/iconfont.7dbaeeb2.woff2";